import { Component } from "react";
import PropTypes from "prop-types";
import constants from "../../utils/constants";

const staticVariables = {
  [constants.STEP_PATHS.HEALTH_CHECK]: {},
  [constants.STEP_PATHS.SHARE_BOOKING]: {},
  [constants.STEP_PATHS.RECOVER_RESERVATION_CONFIRMATION]: {},
  [constants.PAYMENT_TYPES.WITBOOKING]: {},
  [constants.STEP_PATHS.STEP_1]: {
    PAGE_CATEGORY: "proceso de reserva hotel",
    PAGE_SUBCATEGORY: "Step 1-selección habitación",
    VIEW_NAME: "CHECKOUT_PROCESS_VIEW",
    VIEW_TYPE: "CHECKOUT-SELECCION_HABITACION",
  },
  [constants.STEP_PATHS.STEP_2]: {
    PAGE_CATEGORY: "proceso de reserva hotel",
    PAGE_SUBCATEGORY: "Step 2-personalizar estancia y datos personales",
    VIEW_NAME: "CHECKOUT_PROCESS_VIEW",
    VIEW_TYPE: "CHECKOUT-DATOS_RESERVAINFORMACION_PERSONAL",
  },
  [constants.STEP_PATHS.STEP_3]: {
    PAGE_CATEGORY: "booking confirmation",
    PAGE_SUBCATEGORY: "Step 3-confirmación de la reserva",
    VIEW_NAME: "CHECKOUT_ORDER_CONFIRMATION",
    VIEW_TYPE: "CHECKOUT-CONFIRMATION",
  },
  [constants.STEP_PATHS.STEP_4]: {
    PAGE_CATEGORY: "booking modification",
    PAGE_SUBCATEGORY: "Step 4-modificación de la reserva",
    VIEW_NAME: "CHECKOUT_ORDER_MODIFICATION",
    VIEW_TYPE: "CHECKOUT-MODIFICATION",
  },
};

function pushDataLayer(dataLayer) {
  if (window && window.dataLayer) {
    window.dataLayer.push(dataLayer);
  } else {
    window.dataLayer = [dataLayer];
  }
}

function pushVirtualPage() {
  window.dataLayer.push({
    event: "VirtualPageview",
    virtualPageURL: window.location.pathname,
    virtualPageTitle: document.title,
  });
}

function pushEvents({ event, eventCategory, eventAction, eventLabel }) {
  pushVirtualPage();
  window.dataLayer.push({
    eventCategory,
    eventAction,
    eventLabel,
    event,
  });
}

class DataLayerTracker extends Component {
  constructor(props) {
    super(props);
    this.state = { initializedDataLayer: false };
  }

  getDataLayer = () => {
    const { wbkDataLayer, currentStep } = this.props;
    const location = window.location;
    return {
      ...wbkDataLayer,
      FunnelVirtualPage: `${location.protocol}//${location.host}${location.pathname}`,
      pageCategory: staticVariables[currentStep] && staticVariables[currentStep].PAGE_CATEGORY,
      pageSubCategory:
        staticVariables[currentStep] && staticVariables[currentStep].PAGE_SUBCATEGORY,
      viewName: staticVariables[currentStep] && staticVariables[currentStep].VIEW_NAME,
      viewType: staticVariables[currentStep] && staticVariables[currentStep].VIEW_TYPE,
    };
  };

  componentDidMount() {
    // Lands on chain's property selection
    window.addEventListener(constants.EVENTS.START_STEP_ZERO, () => {
      pushDataLayer(this.getDataLayer());
      pushEvents({
        eventCategory: constants.DATALAYER_EVENTS.PROPERTY_SELECTION.EVENT_CATEGORY,
        eventAction: constants.DATALAYER_EVENTS.PROPERTY_SELECTION.EVENT_ACTION,
        eventLabel: window.wbkPropertyName,
        event: constants.DATALAYER_EVENTS.PROPERTY_SELECTION.EVENT,
      });
    });

    // Lands on room selection
    window.addEventListener(constants.EVENTS.START_STEP_ONE, () => {
      pushDataLayer(this.getDataLayer());
      pushEvents({
        eventCategory: constants.DATALAYER_EVENTS.ACCOMMODATION_SELECTION.EVENT_CATEGORY,
        eventAction: constants.DATALAYER_EVENTS.ACCOMMODATION_SELECTION.EVENT_ACTION,
        eventLabel: window.wbkPropertyName,
        event: constants.DATALAYER_EVENTS.ACCOMMODATION_SELECTION.EVENT,
      });
    });

    // Lands on inventory selection
    window.addEventListener(constants.EVENTS.START_STEP_TWO, () => {
      pushDataLayer(this.getDataLayer());
      pushEvents({
        eventCategory: constants.DATALAYER_EVENTS.INVENTORY.EVENT_CATEGORY,
        eventAction: constants.DATALAYER_EVENTS.INVENTORY.EVENT_ACTION,
        eventLabel: window.wbkPropertyName,
        event: constants.DATALAYER_EVENTS.INVENTORY.EVENT,
      });
    });

    // Lands on checkout
    window.addEventListener(constants.EVENTS.START_STEP_THREE, () => {
      pushDataLayer(this.getDataLayer());
      pushEvents({
        eventCategory: constants.DATALAYER_EVENTS.CHECKOUT.EVENT_CATEGORY,
        eventAction: constants.DATALAYER_EVENTS.CHECKOUT.EVENT_ACTION,
        eventLabel: window.wbkPropertyName,
        event: constants.DATALAYER_EVENTS.CHECKOUT.EVENT,
      });
    });

    // Lands on booking confirmation
    window.addEventListener(constants.EVENTS.RESERVATION_RECEIPT, () => {
      pushDataLayer(this.getDataLayer());
      pushEvents({
        eventCategory: constants.DATALAYER_EVENTS.RESERVATION_RECEIPT.EVENT_CATEGORY,
        eventAction: constants.DATALAYER_EVENTS.RESERVATION_RECEIPT.EVENT_ACTION,
        eventLabel: window.wbkPropertyName,
        event: constants.DATALAYER_EVENTS.RESERVATION_RECEIPT.EVENT,
      });
    });

    // Lands on booking confirmation with reservation success
    window.addEventListener(constants.EVENTS.RESERVATION_SUCCESS, () => {
      pushDataLayer(this.getDataLayer());
      window.dataLayer.push({ event: "transactionObjectReady" });
      pushEvents({
        eventCategory: constants.DATALAYER_EVENTS.RESERVATION_SUCCESS.EVENT_CATEGORY,
        eventAction: constants.DATALAYER_EVENTS.RESERVATION_SUCCESS.EVENT_ACTION,
        eventLabel: window.wbkPropertyName,
        event: constants.DATALAYER_EVENTS.RESERVATION_SUCCESS.EVENT,
      });
    });

    // Opened services modal
    window.addEventListener(constants.EVENTS.OPENED_SERVICES_MODAL, () => {
      pushDataLayer(this.getDataLayer());
      pushEvents({
        eventCategory: constants.DATALAYER_EVENTS.SERVICES.EVENT_CATEGORY,
        eventAction: constants.DATALAYER_EVENTS.SERVICES.EVENT_ACTION,
        eventLabel: window.wbkPropertyName,
        event: constants.DATALAYER_EVENTS.SERVICES.EVENT,
      });
    });

    // Cancel reservation
    window.addEventListener(constants.EVENTS.CANCEL_RESERVATION, () => {
      pushDataLayer(this.getDataLayer());
      pushEvents({
        eventCategory: constants.DATALAYER_EVENTS.CANCEL_RESERVATION.EVENT_CATEGORY,
        eventAction: constants.DATALAYER_EVENTS.CANCEL_RESERVATION.EVENT_ACTION,
        eventLabel: window.wbkPropertyName,
        event: constants.DATALAYER_EVENTS.CANCEL_RESERVATION.EVENT,
      });
    });

    // Changed booking form and searched
    window.addEventListener(constants.EVENTS.CHANGED_BOOKING_FORM, () => {
      pushDataLayer(this.getDataLayer());
      pushEvents({
        eventCategory: constants.DATALAYER_EVENTS.CHANGED_BOOKING_FORM.EVENT_CATEGORY,
        eventAction: constants.DATALAYER_EVENTS.CHANGED_BOOKING_FORM.EVENT_ACTION,
        eventLabel: window.wbkPropertyName,
        event: constants.DATALAYER_EVENTS.CHANGED_BOOKING_FORM.EVENT,
      });
    });
  }

  render() {
    return null;
  }
}

DataLayerTracker.propTypes = {
  wbkDataLayer: PropTypes.object.isRequired,
  currentStep: PropTypes.string.isRequired,
};

export default DataLayerTracker;
